import { useState } from "react";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { Button, Paper, Typography } from "@mui/material";
import logo from "../assets/Images/SPCLEP.jpg";
import Lang from "../Utils/lang";
import style from "./Login.module.scss";
import { enumUrl } from "../Utils/utils";
import { postData } from "../Services/postData";
import { useNavigate } from "react-router-dom";

const lang = Lang.getInstance();

function Login() {
  const [user, setUser] = useState({
    username: "",
    password: "",
  });
  const [errorText, setErrorText] = useState("");
  const navigate = useNavigate();

  /**
   *
   */
  async function onSubmit() {
    try {
      const response = await postData(enumUrl.login, user);
      if (response.data) {
        localStorage.setItem("userId", response.data.userId);
        localStorage.setItem("userName", response.data.userName);
        localStorage.setItem("access_token", response.data.access_token);
        localStorage.setItem("roles", response.data.roles.join(","));
        navigate("/?isValidated=false?page=1?perPage=10");
        window.location.reload();
      }
    } catch (err) {
      if (err.response.status === 401)
        setErrorText("Numele de utilizator sau parola sunt incorecte!");
    }
  }

  /**
   *
   * @param {*} event
   */
  function onChange(event) {
    let newUser = Object.assign({}, user);
    newUser[event.target.name] = event.target.value;
    setUser(newUser);
  }

  return (
    <div className={style.container}>
      <Paper className={style.paper}>
        <div>
          <img src={logo} alt="Politia" height="50" style={{ marginTop: 10 }} />
          <Typography className={style.title}>{lang.get("login")}</Typography>
        </div>
        <ValidatorForm onSubmit={onSubmit}>
          <TextValidator
            label={lang.get("username")}
            type="text"
            name="username"
            variant="standard"
            value={user.username}
            onChange={(e) => onChange(e)}
            validators={["required"]}
            errorMessages={[lang.get("textFieldRequired")]}
            className={style.textValidator}
          />
          <TextValidator
            label={lang.get("password")}
            type="password"
            name="password"
            variant="standard"
            value={user.password}
            onChange={onChange}
            validators={["required"]}
            errorMessages={[lang.get("textFieldRequired")]}
            className={style.textValidator}
          />
          <Button type="submit" variant="contained" className={style.submitBtn}>
            {lang.get("login")}
          </Button>
        </ValidatorForm>
        <Typography className={style.errorText}>{errorText}</Typography>
      </Paper>
    </div>
  );
}

export default Login;
